import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import ActivationPage from 'app/activation/Index';
import {
  isActivationTestFlow,
  TEST_ACTIVATION_ROUTE
} from 'core/constants/activationTest';
import { ActivationTestModeProvider } from 'core/context/ActivationTestMode';

import './Index.scss';

const TestActivationWizard = (): JSX.Element => {
  const { flow } = useParams<{ flow: string }>();

  if (!isActivationTestFlow(flow)) {
    return <Navigate to={TEST_ACTIVATION_ROUTE} replace />;
  }

  return (
    <ActivationTestModeProvider flow={flow}>
      <ActivationPage key={flow} />
    </ActivationTestModeProvider>
  );
};

export default TestActivationWizard;
